exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (max-width: 991px) {\n.pl-4[data-v-429950bb], .px-4[data-v-429950bb] {\n        padding-left: 1rem !important;\n}\n}\n", ""]);

// exports
